'use client';
/* Built In Imports */
import { useEffect, useState } from 'react';
/* External Imports */
import { Box, Center } from '@chakra-ui/react';
import config from '@config';
import { setBannerAudioPlayer } from '@app-ps/Components/Utility/utils';

const BannerAudioEmbed = ({ sectionContent, region, lang }) => {
  const [isAudioLoad, setAudioLoad] = useState(false);
  const handleAudioClick = () => {
    if (!isAudioLoad) {
      setAudioLoad(true);
    }
  };
  useEffect(() => {
    if (typeof window !== 'undefined' && isAudioLoad) {
      setBannerAudioPlayer(sectionContent?.embedUrl);
    }
  }, [isAudioLoad]);
  return (
    <Box
      className="banner-audio-player"
      h={{ base: '52px', md: '90px' }}
      mt={{ base: '-52px', md: '-90px' }}
    >
      <Box className="controls" mt={{ base: '8px', md: '16px' }}>
        <Box className="time" visibility="hidden" w="1px">
          <Box className="current"></Box>
          <Box className="length"></Box>
        </Box>
        <Box className="play-container" alignSelf="center" ml="10%">
          <Center
            bg="rgba(254, 250, 246, .1)"
            rounded="full"
            className="rewind"
            h={{ base: '32px', md: '48px' }}
            w={{ base: '32px', md: '48px' }}
            backgroundSize="contain"
            mr="16px"
            cursor="pointer"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24px"
              height="24px"
              viewBox="0 0 24px 24px"
              fill="none"
            >
              <path
                d="M11.4987 14V19L2.16536 12L11.4987 5V10V11L12.2987 10.4L19.4987 5V19L12.2987 13.6L11.4987 13V14Z"
                fill="#FEFAF6"
                stroke="#FEFAF6"
              />
            </svg>
          </Center>
          <Box
            className="toggle-play play"
            h={{ base: '32px', md: '48px' }}
            w={{ base: '32px', md: '48px' }}
            backgroundSize="contain"
            onClick={handleAudioClick}
          ></Box>
          <Center
            className="forward"
            bg="rgba(254, 250, 246, .1)"
            rounded="full"
            h={{ base: '32px', md: '48px' }}
            w={{ base: '32px', md: '48px' }}
            backgroundSize="contain"
            ml="16px"
            cursor="pointer"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24px"
              height="24px"
              viewBox="0 0 24px 24px"
              fill="none"
            >
              <path
                d="M12.5 10V5L21.8333 12L12.5 19V14V13L11.7 13.6L4.5 19V5L11.7 10.4L12.5 11V10Z"
                fill="#FEFAF6"
                stroke="#FEFAF6"
              />
            </svg>
          </Center>
        </Box>
        <Box
          className="volume-container"
          bg="rgba(254, 250, 246, .1)"
          px={{ base: '4px', md: '16px' }}
        >
          <Box className="volume-button">
            <Box
              className="volume icono-volumeMedium"
              backgroundSize="contain"
              mr={{ md: '12px' }}
              h={{ base: '16px', md: '24px' }}
              w={{ base: '16px', md: '24px' }}
              backgroundRepeat="no-repeat"
            ></Box>
          </Box>
          <Box className="volume-slider" width={{ base: '0', md: '40px' }}>
            <Box className="volume-percentage"></Box>
          </Box>
        </Box>
      </Box>
      <Box
        className="timeline"
        mt={{ base: '.5rem', md: '1rem' }}
        width="100%"
        float="left"
        background="#979797"
        height={{ base: '4px', md: '8px' }}
        padding="0"
      >
        <Box className="progress"></Box>
      </Box>
      <style global jsx>
        {`
          .isha-audio-player {
            margin-top: 21px;
          }
          .banner-audio-player {
            background-color: rgba(1, 5, 9, 1);
            padding: 0;
          }
          .banner-audio-player
            .controls
            .volume-container
            .volume-button
            .icono-volumeMedium {
            background-image: url(${config.imgPath}/d/46272/1728042703-vector.png);
          }
          .banner-audio-player
            .controls
            .volume-container
            .volume-button
            .icono-volumeMute {
            background-image: url(${config.imgPath}/d/46272/1728042592-volume-x.png);
          }
          .banner-audio-player .audio {
            width: 720px;
            height: 80px;
            opacity: 0.9;
            color: #d8d8d8;
          }
          .banner-audio-player .timeline {
            width: 100%;
            float: left;
            background: #979797;
            padding: 0;
          }
          @media only screen and (max-width: 500px) {
            .banner-audio-player .timeline {
              width: 100%;
            }
            .article-right-blue {
              background-position-x: 95%;
            }
          }
          .banner-audio-player {
            width: 100%;
            background: #010509;
            font-family: arial;
            color: rgb(255 255 255);
            font-size: 0.75em;
            overflow: hidden;
            opacity: 0.84;
          }
          .banner-audio-player .timeline {
            background: #f1ede9;
            width: 100%;
            left: 0px;
            position: relative;
            cursor: pointer;
          }
          .banner-audio-player .timeline .progress {
            background: #60adff;
            width: 0%;
            height: 100%;
            transition: 0.25s;
          }
          .banner-audio-player .timeline .progress:after {
            width: 20px;
            background: red;
            height: 20px;
          }
          .banner-audio-player .controls {
            display: flex;
            justify-content: space-between;
            align-items: stretch;
            padding: 0 20px;
          }
          .banner-audio-player .controls > * {
            display: flex;
            justify-content: center;
            align-items: center;
          }
          .banner-audio-player .controls .toggle-play.play {
            cursor: pointer;
            position: relative;
            border: none;
            background-repeat: no-repeat;
            background-position: center;
            background-size: contain;
            outline: none;
            font-family: 'var(--FedraSansStd-medium)';
            background-image: url(${config.imgPath}/d/46272/1727950650-state-hover-size-big.png);
          }
          .banner-audio-player .controls .toggle-play.play:hover {
            transform: scale(1.1);
          }
          .banner-audio-player .controls .toggle-play.pause {
            position: relative;
            border: none;
            background-repeat: no-repeat;
            background-size: contain;
            background-position: center;
            outline: none;
            font-family: 'var(--FedraSansStd-medium)';
            background-image: url('https://static.sadhguru.org/d/46272/1731229860-pauseicon-topbutton.png');

             {
              /* background-image: url(${config.imgPath}/d/46272/1727950650-state-resting-size-big.png); */
            }
          }
          .banner-audio-player .controls .time {
            display: flex;
            color: rgba(254, 250, 246, 1);
            margin-top: -25px;
            font-family: 'FedraSerifAStdBook';
            font-size: 13px;
          }
          .banner-audio-player .controls .time > * {
            padding: 2px;
          }
          .banner-audio-player .controls .volume-container {
            cursor: pointer;
            position: relative;
            z-index: 2;
          }
          .banner-audio-player .controls .volume-container .volume-button {
            height: 26px;
            display: flex;
            align-items: center;
          }
          .banner-audio-player .controls .volume-container .volume-slider {
            height: 5px;
            background: #fefaf6;
            box-shadow: 0 0 20px #000a;
            transition: 0.25s;
          }
          .banner-audio-player
            .controls
            .volume-container
            .volume-slider
            .volume-percentage {
            background: #80bdff;
            height: 100%;
            width: 75%;
          }
        `}
      </style>
    </Box>
  );
};
export default BannerAudioEmbed;
